var map = {
	"./complete/complete-icon.png": "NdK1",
	"./drive/drive-icon.png": "OdcN",
	"./fundamentals/fundamentals-icon.png": "t5vH",
	"./home/tools/complete-icon.png": "M+Gm",
	"./home/tools/drive-icon.png": "z+aF",
	"./home/tools/fundamentals-icon.png": "z/Ou",
	"./home/tools/job-description-generator-icon.png": "VKV5",
	"./home/tools/live-hr-advice-icon.png": "4I/s",
	"./home/tools/policy-manual-wizard-icon.png": "eDQa",
	"./home/tools/surveys-icon.png": "sH9r",
	"./home/tools/time-attendance-icon.png": "XcBi",
	"./home/tools/training-icon.png": "76Ig",
	"./job-description-generator/job-description-generator-icon.png": "AkH4",
	"./live-hr-advice/live-hr-advice-icon.png": "/HLr",
	"./policy-manual-wizard/policy-manual-wizard-icon.png": "k8J3",
	"./surveys/surveys-icon.png": "BTB+",
	"./time-attendance/live-hr-advice-icon.png": "7tKQ",
	"./time-attendance/time-attendance-icon.png": "c6pl",
	"./training/training-icon.png": "1HHV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WVvy";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\-icon\.png$
// module id = WVvy
// module chunks = 0